export interface Vocab {
  hanzi: string;
  pinyin: string;
  meaning: string; // Nghĩa tiếng Việt
}

export interface DialogueLine {
  speaker: string;
  hanzi: string;
  pinyin: string;
  meaning: string;
}

export interface Lesson {
  id: string;
  title: string;
  description: string;
  vocab: Vocab[];
  dialogue: DialogueLine[];
}

export const lessons: Lesson[] = [
  {
    id: "bai-1",
    title: "Bài 1: Chào hỏi",
    description: "Học cách chào hỏi cơ bản và giới thiệu tên.",
    vocab: [
      { hanzi: "你好", pinyin: "Nǐ hǎo", meaning: "Xin chào" },
      { hanzi: "您好", pinyin: "Nín hǎo", meaning: "Xin chào (lịch sự)" },
      { hanzi: "我是", pinyin: "Wǒ shì", meaning: "Tôi là" },
      { hanzi: "很高兴", pinyin: "Hěn gāoxìng", meaning: "Rất vui" },
      { hanzi: "认识", pinyin: "Rènshi", meaning: "Quen biết" },
      { hanzi: "再见", pinyin: "Zàijiàn", meaning: "Tạm biệt" },
      { hanzi: "早上好", pinyin: "Zǎoshang hǎo", meaning: "Chào buổi sáng" },
      { hanzi: "晚上好", pinyin: "Wǎnshang hǎo", meaning: "Chào buổi tối" },
      {
        hanzi: "好久不见",
        pinyin: "Hǎojiǔ bùjiàn",
        meaning: "Lâu rồi không gặp",
      },
      {
        hanzi: "最近怎么样",
        pinyin: "Zuìjìn zěnmeyàng",
        meaning: "Dạo này thế nào",
      },
      { hanzi: "朋友", pinyin: "Péngyou", meaning: "Bạn bè" },
      { hanzi: "同事", pinyin: "Tóngshì", meaning: "Đồng nghiệp" },
      { hanzi: "先生", pinyin: "Xiānsheng", meaning: "Quý ông" },
      { hanzi: "女士", pinyin: "Nǚshì", meaning: "Quý bà" },
      { hanzi: "同学", pinyin: "Tóngxué", meaning: "Bạn học" },
      { hanzi: "老师", pinyin: "Lǎoshī", meaning: "Thầy/cô giáo" },
      { hanzi: "请问", pinyin: "Qǐngwèn", meaning: "Xin hỏi" },
      { hanzi: "谢谢", pinyin: "Xièxie", meaning: "Cảm ơn" },
      { hanzi: "不客气", pinyin: "Bù kèqì", meaning: "Không có gì" },
      { hanzi: "对不起", pinyin: "Duìbuqǐ", meaning: "Xin lỗi" },
    ],
    dialogue: [
      {
        speaker: "A",
        hanzi: "你好！",
        pinyin: "Nǐ hǎo!",
        meaning: "Xin chào!",
      },
      {
        speaker: "B",
        hanzi: "你好！我是南。",
        pinyin: "Nǐ hǎo! Wǒ shì Nán.",
        meaning: "Chào bạn! Tôi là Nam.",
      },
      {
        speaker: "A",
        hanzi: "很高兴认识你。",
        pinyin: "Hěn gāoxìng rènshi nǐ.",
        meaning: "Rất vui được làm quen.",
      },
      {
        speaker: "B",
        hanzi: "我也很高兴。你叫什么名字？",
        pinyin: "Wǒ yě hěn gāoxìng. Nǐ jiào shénme míngzi?",
        meaning: "Tôi cũng rất vui. Bạn tên là gì?",
      },
      {
        speaker: "A",
        hanzi: "我叫明。我是中国人。",
        pinyin: "Wǒ jiào Míng. Wǒ shì Zhōngguó rén.",
        meaning: "Tôi tên là Minh. Tôi là người Trung Quốc.",
      },
      {
        speaker: "B",
        hanzi: "我是越南人。你会说越南语吗？",
        pinyin: "Wǒ shì Yuènán rén. Nǐ huì shuō Yuènányǔ ma?",
        meaning: "Tôi là người Việt Nam. Bạn có biết nói tiếng Việt không?",
      },
      {
        speaker: "A",
        hanzi: "我会说一点越南语。你呢？你会说中文吗？",
        pinyin: "Wǒ huì shuō yīdiǎn Yuènányǔ. Nǐ ne? Nǐ huì shuō Zhōngwén ma?",
        meaning:
          "Tôi biết nói một chút tiếng Việt. Còn bạn? Bạn biết nói tiếng Trung không?",
      },
      {
        speaker: "B",
        hanzi: "我正在学中文。我的中文不太好。",
        pinyin: "Wǒ zhèngzài xué Zhōngwén. Wǒ de Zhōngwén bù tài hǎo.",
        meaning: "Tôi đang học tiếng Trung. Tiếng Trung của tôi không tốt lắm.",
      },
      {
        speaker: "A",
        hanzi: "没关系。我们可以互相学习。",
        pinyin: "Méi guānxi. Wǒmen kěyǐ hùxiāng xuéxí.",
        meaning: "Không sao. Chúng ta có thể cùng nhau học hỏi.",
      },
      {
        speaker: "B",
        hanzi: "太好了！你的越南语很棒。",
        pinyin: "Tài hǎo le! Nǐ de Yuènányǔ hěn bàng.",
        meaning: "Tuyệt vời! Tiếng Việt của bạn rất giỏi.",
      },
    ],
  },
  {
    id: "bai-2",
    title: "Bài 2: Mua sắm",
    description: "Hỏi giá cả và mặc cả đơn giản.",
    vocab: [
      { hanzi: "多少钱", pinyin: "Duōshǎo qián", meaning: "Bao nhiêu tiền" },
      { hanzi: "太贵了", pinyin: "Tài guì le", meaning: "Đắt quá" },
      { hanzi: "便宜", pinyin: "Piányí", meaning: "Rẻ" },
      { hanzi: "这个", pinyin: "Zhège", meaning: "Cái này" },
      { hanzi: "买", pinyin: "Mǎi", meaning: "Mua" },
      { hanzi: "卖", pinyin: "Mài", meaning: "Bán" },
      { hanzi: "商店", pinyin: "Shāngdiàn", meaning: "Cửa hàng" },
      { hanzi: "市场", pinyin: "Shìchǎng", meaning: "Chợ" },
      { hanzi: "价格", pinyin: "Jiàgé", meaning: "Giá cả" },
      { hanzi: "打折", pinyin: "Dǎzhé", meaning: "Giảm giá" },
      { hanzi: "付钱", pinyin: "Fù qián", meaning: "Trả tiền" },
      { hanzi: "现金", pinyin: "Xiànjīn", meaning: "Tiền mặt" },
      { hanzi: "信用卡", pinyin: "Xìnyòngkǎ", meaning: "Thẻ tín dụng" },
      { hanzi: "找零", pinyin: "Zhǎo líng", meaning: "Tiền thối lại" },
      { hanzi: "质量", pinyin: "Zhìliàng", meaning: "Chất lượng" },
      { hanzi: "试穿", pinyin: "Shì chuān", meaning: "Thử đồ" },
      { hanzi: "大小", pinyin: "Dàxiǎo", meaning: "Kích cỡ" },
      { hanzi: "颜色", pinyin: "Yánsè", meaning: "Màu sắc" },
      { hanzi: "合适", pinyin: "Héshì", meaning: "Phù hợp" },
      { hanzi: "购物", pinyin: "Gòuwù", meaning: "Mua sắm" },
    ],
    dialogue: [
      {
        speaker: "A",
        hanzi: "老板，这个多少钱？",
        pinyin: "Lǎobǎn, zhège duōshǎo qián?",
        meaning: "Ông chủ, cái này bao nhiêu tiền?",
      },
      {
        speaker: "B",
        hanzi: "这个一百块。",
        pinyin: "Zhège yībǎi kuài.",
        meaning: "Cái này 100 tệ.",
      },
      {
        speaker: "A",
        hanzi: "太贵了！便宜一点吧。",
        pinyin: "Tài guì le! Piányí yīdiǎn ba.",
        meaning: "Đắt quá! Bớt chút đi.",
      },
      {
        speaker: "B",
        hanzi: "好吧，八十块。",
        pinyin: "Hǎo ba, bāshí kuài.",
        meaning: "Được thôi, 80 tệ.",
      },
      {
        speaker: "A",
        hanzi: "五十块可以吗？",
        pinyin: "Wǔshí kuài kěyǐ ma?",
        meaning: "50 tệ được không?",
      },
      {
        speaker: "B",
        hanzi: "五十块太便宜了。七十块吧。",
        pinyin: "Wǔshí kuài tài piányí le. Qīshí kuài ba.",
        meaning: "50 tệ rẻ quá. 70 tệ đi.",
      },
      {
        speaker: "A",
        hanzi: "六十五块，可以吗？",
        pinyin: "Liùshíwǔ kuài, kěyǐ ma?",
        meaning: "65 tệ, được chứ?",
      },
      {
        speaker: "B",
        hanzi: "好吧，成交。你要几个？",
        pinyin: "Hǎo ba, chéngjiāo. Nǐ yào jǐ gè?",
        meaning: "Được rồi, đồng ý. Bạn muốn mấy cái?",
      },
      {
        speaker: "A",
        hanzi: "我要两个。有别的颜色吗？",
        pinyin: "Wǒ yào liǎng gè. Yǒu bié de yánsè ma?",
        meaning: "Tôi muốn hai cái. Có màu khác không?",
      },
      {
        speaker: "B",
        hanzi: "有红色、蓝色和白色。",
        pinyin: "Yǒu hóngsè, lánsè hé báisè.",
        meaning: "Có màu đỏ, xanh dương và trắng.",
      },
      {
        speaker: "A",
        hanzi: "我要一个红色的和一个蓝色的。可以用信用卡吗？",
        pinyin:
          "Wǒ yào yī gè hóngsè de hé yī gè lánsè de. Kěyǐ yòng xìnyòngkǎ ma?",
        meaning:
          "Tôi muốn một cái màu đỏ và một cái màu xanh. Có thể dùng thẻ tín dụng không?",
      },
      {
        speaker: "B",
        hanzi: "可以。一共一百三十块。",
        pinyin: "Kěyǐ. Yīgòng yībǎi sānshí kuài.",
        meaning: "Được. Tổng cộng 130 tệ.",
      },
    ],
  },
  {
    id: "bai-3",
    title: "Bài 3: Thời gian",
    description: "Hỏi giờ và nói về thời gian trong ngày.",
    vocab: [
      { hanzi: "现在", pinyin: "Xiànzài", meaning: "Bây giờ" },
      { hanzi: "几点", pinyin: "Jǐ diǎn", meaning: "Mấy giờ" },
      { hanzi: "今天", pinyin: "Jīntiān", meaning: "Hôm nay" },
      { hanzi: "忙", pinyin: "Máng", meaning: "Bận" },
      { hanzi: "有空", pinyin: "Yǒu kòng", meaning: "Rảnh rỗi" },
      { hanzi: "时间", pinyin: "Shíjiān", meaning: "Thời gian" },
      { hanzi: "分钟", pinyin: "Fēnzhōng", meaning: "Phút" },
      { hanzi: "小时", pinyin: "Xiǎoshí", meaning: "Giờ" },
      { hanzi: "早上", pinyin: "Zǎoshang", meaning: "Buổi sáng" },
      { hanzi: "下午", pinyin: "Xiàwǔ", meaning: "Buổi chiều" },
      { hanzi: "晚上", pinyin: "Wǎnshang", meaning: "Buổi tối" },
      { hanzi: "半夜", pinyin: "Bànyè", meaning: "Nửa đêm" },
      { hanzi: "约会", pinyin: "Yuēhuì", meaning: "Cuộc hẹn" },
      { hanzi: "迟到", pinyin: "Chídào", meaning: "Đến muộn" },
      { hanzi: "早到", pinyin: "Zǎo dào", meaning: "Đến sớm" },
      { hanzi: "准时", pinyin: "Zhǔnshí", meaning: "Đúng giờ" },
      { hanzi: "日历", pinyin: "Rìlì", meaning: "Lịch" },
      { hanzi: "星期", pinyin: "Xīngqī", meaning: "Tuần" },
      { hanzi: "月份", pinyin: "Yuèfèn", meaning: "Tháng" },
      { hanzi: "年份", pinyin: "Niánfèn", meaning: "Năm" },
    ],
    dialogue: [
      {
        speaker: "A",
        hanzi: "请问，现在几点？",
        pinyin: "Qǐngwèn, xiànzài jǐ diǎn?",
        meaning: "Xin hỏi, bây giờ là mấy giờ?",
      },
      {
        speaker: "B",
        hanzi: "现在是下午两点半。",
        pinyin: "Xiànzài shì xiàwǔ liǎng diǎn bàn.",
        meaning: "Bây giờ là 2 rưỡi chiều.",
      },
      {
        speaker: "A",
        hanzi: "今天你忙吗？",
        pinyin: "Jīntiān nǐ máng ma?",
        meaning: "Hôm nay bạn có bận không?",
      },
      {
        speaker: "B",
        hanzi: "我不忙，我有空。",
        pinyin: "Wǒ bù máng, wǒ yǒu kòng.",
        meaning: "Tôi không bận, tôi rảnh.",
      },
      {
        speaker: "A",
        hanzi: "太好了！我们下午四点见面可以吗？",
        pinyin: "Tài hǎo le! Wǒmen xiàwǔ sì diǎn jiànmiàn kěyǐ ma?",
        meaning: "Tuyệt vời! Chúng ta gặp nhau lúc 4 giờ chiều được không?",
      },
      {
        speaker: "B",
        hanzi: "四点我有事。五点可以吗？",
        pinyin: "Sì diǎn wǒ yǒu shì. Wǔ diǎn kěyǐ ma?",
        meaning: "4 giờ tôi có việc. 5 giờ được không?",
      },
      {
        speaker: "A",
        hanzi: "五点也可以。在哪里见面？",
        pinyin: "Wǔ diǎn yě kěyǐ. Zài nǎlǐ jiànmiàn?",
        meaning: "5 giờ cũng được. Gặp nhau ở đâu?",
      },
      {
        speaker: "B",
        hanzi: "在咖啡店见面吧。",
        pinyin: "Zài kāfēi diàn jiànmiàn ba.",
        meaning: "Gặp nhau ở quán cà phê đi.",
      },
      {
        speaker: "A",
        hanzi: "好的。不要迟到哦！",
        pinyin: "Hǎo de. Bùyào chídào ó!",
        meaning: "Được. Đừng đến muộn nhé!",
      },
      {
        speaker: "B",
        hanzi: "我会准时的。明天你有什么计划？",
        pinyin: "Wǒ huì zhǔnshí de. Míngtiān nǐ yǒu shénme jìhuà?",
        meaning: "Tôi sẽ đúng giờ. Ngày mai bạn có kế hoạch gì?",
      },
      {
        speaker: "A",
        hanzi: "明天我要去上班。",
        pinyin: "Míngtiān wǒ yào qù shàngbān.",
        meaning: "Ngày mai tôi phải đi làm.",
      },
      {
        speaker: "B",
        hanzi: "你周末有空吗？",
        pinyin: "Nǐ zhōumò yǒu kòng ma?",
        meaning: "Cuối tuần bạn có rảnh không?",
      },
      {
        speaker: "A",
        hanzi: "周末我有空。我们可以一起吃饭。",
        pinyin: "Zhōumò wǒ yǒu kòng. Wǒmen kěyǐ yīqǐ chīfàn.",
        meaning: "Cuối tuần tôi rảnh. Chúng ta có thể cùng nhau ăn cơm.",
      },
    ],
  },
  {
    id: "bai-4",
    title: "Bài 4: Gọi món",
    description: "Đặt món ăn tại nhà hàng.",
    vocab: [
      { hanzi: "服务员", pinyin: "Fúwùyuán", meaning: "Phục vụ" },
      { hanzi: "菜单", pinyin: "Càidān", meaning: "Thực đơn/Menu" },
      { hanzi: "吃", pinyin: "Chī", meaning: "Ăn" },
      { hanzi: "面条", pinyin: "Miàntiáo", meaning: "Mì" },
      { hanzi: "好吃", pinyin: "Hǎochī", meaning: "Ngon" },
      { hanzi: "餐厅", pinyin: "Cāntīng", meaning: "Nhà hàng" },
      { hanzi: "点菜", pinyin: "Diǎn cài", meaning: "Gọi món" },
      { hanzi: "主食", pinyin: "Zhǔshí", meaning: "Món chính" },
      { hanzi: "饮料", pinyin: "Yǐnliào", meaning: "Đồ uống" },
      { hanzi: "汤", pinyin: "Tāng", meaning: "Canh/Súp" },
      { hanzi: "甜点", pinyin: "Tiándiǎn", meaning: "Món tráng miệng" },
      { hanzi: "辣的", pinyin: "Là de", meaning: "Cay" },
      { hanzi: "咸的", pinyin: "Xián de", meaning: "Mặn" },
      { hanzi: "甜的", pinyin: "Tián de", meaning: "Ngọt" },
      { hanzi: "酸的", pinyin: "Suān de", meaning: "Chua" },
      { hanzi: "筷子", pinyin: "Kuàizi", meaning: "Đũa" },
      { hanzi: "勺子", pinyin: "Sháozi", meaning: "Thìa" },
      { hanzi: "盘子", pinyin: "Pánzi", meaning: "Đĩa" },
      { hanzi: "杯子", pinyin: "Bēizi", meaning: "Ly/Cốc" },
      { hanzi: "结账", pinyin: "Jiézhàng", meaning: "Tính tiền" },
    ],
    dialogue: [
      {
        speaker: "A",
        hanzi: "服务员，我要点菜。",
        pinyin: "Fúwùyuán, wǒ yào diǎn cài.",
        meaning: "Phục vụ, tôi muốn gọi món.",
      },
      {
        speaker: "B",
        hanzi: "你想吃什么？",
        pinyin: "Nǐ xiǎng chī shénme?",
        meaning: "Quý khách muốn ăn gì?",
      },
      {
        speaker: "A",
        hanzi: "我要一碗牛肉面。",
        pinyin: "Wǒ yào yī wǎn niúròu miàn.",
        meaning: "Cho tôi một bát mì bò.",
      },
      {
        speaker: "B",
        hanzi: "好的，请稍等。",
        pinyin: "Hǎo de, qǐng shāo děng.",
        meaning: "Vâng, xin chờ một chút.",
      },
      {
        speaker: "A",
        hanzi: "请给我菜单看一下。",
        pinyin: "Qǐng gěi wǒ càidān kàn yīxià.",
        meaning: "Cho tôi xem thực đơn.",
      },
      {
        speaker: "B",
        hanzi: "这是菜单。我们有炒饭、饺子和很多菜。",
        pinyin: "Zhè shì càidān. Wǒmen yǒu chǎofàn, jiǎozi hé hěnduō cài.",
        meaning:
          "Đây là thực đơn. Chúng tôi có cơm rang, bánh chẻo và nhiều món khác.",
      },
      {
        speaker: "A",
        hanzi: "你们有什么特色菜？",
        pinyin: "Nǐmen yǒu shénme tèsè cài?",
        meaning: "Quán có món đặc sản gì?",
      },
      {
        speaker: "B",
        hanzi: "我们的宫保鸡丁很有名。",
        pinyin: "Wǒmen de gōngbǎo jīdīng hěn yǒumíng.",
        meaning: "Món gà xào cay của chúng tôi rất nổi tiếng.",
      },
      {
        speaker: "A",
        hanzi: "那我要一份宫保鸡丁。不要太辣。",
        pinyin: "Nà wǒ yào yī fèn gōngbǎo jīdīng. Bùyào tài là.",
        meaning: "Vậy cho tôi một phần gà xào cay. Đừng quá cay.",
      },
      {
        speaker: "B",
        hanzi: "好的。要喝什么饮料？",
        pinyin: "Hǎo de. Yào hē shénme yǐnliào?",
        meaning: "Được. Muốn uống gì?",
      },
      {
        speaker: "A",
        hanzi: "一瓶啤酒。",
        pinyin: "Yī píng píjiǔ.",
        meaning: "Một chai bia.",
      },
      {
        speaker: "B",
        hanzi: "还要别的吗？",
        pinyin: "Hái yào bié de ma?",
        meaning: "Còn muốn gì nữa không?",
      },
      {
        speaker: "A",
        hanzi: "不要了，谢谢。",
        pinyin: "Bù yào le, xièxie.",
        meaning: "Không cần nữa, cảm ơn.",
      },
      {
        speaker: "A",
        hanzi: "服务员，结账。",
        pinyin: "Fúwùyuán, jiézhàng.",
        meaning: "Phục vụ, tính tiền.",
      },
    ],
  },
  {
    id: "bai-5",
    title: "Bài 5: Gia đình",
    description: "Giới thiệu về các thành viên trong gia đình.",
    vocab: [
      { hanzi: "家", pinyin: "Jiā", meaning: "Nhà/Gia đình" },
      {
        hanzi: "几口人",
        pinyin: "Jǐ kǒu rén",
        meaning: "Mấy người (nhân khẩu)",
      },
      { hanzi: "爸爸", pinyin: "Bàba", meaning: "Bố" },
      { hanzi: "妈妈", pinyin: "Māma", meaning: "Mẹ" },
      { hanzi: "哥哥", pinyin: "Gēge", meaning: "Anh trai" },
      { hanzi: "姐姐", pinyin: "Jiějie", meaning: "Chị gái" },
      { hanzi: "弟弟", pinyin: "Dìdi", meaning: "Em trai" },
      { hanzi: "妹妹", pinyin: "Mèimei", meaning: "Em gái" },
      { hanzi: "爷爷", pinyin: "Yéye", meaning: "Ông nội" },
      { hanzi: "奶奶", pinyin: "Nǎinai", meaning: "Bà nội" },
      { hanzi: "外公", pinyin: "Wàigōng", meaning: "Ông ngoại" },
      { hanzi: "外婆", pinyin: "Wàipó", meaning: "Bà ngoại" },
      { hanzi: "丈夫", pinyin: "Zhàngfu", meaning: "Chồng" },
      { hanzi: "妻子", pinyin: "Qīzi", meaning: "Vợ" },
      { hanzi: "儿子", pinyin: "Érzi", meaning: "Con trai" },
      { hanzi: "女儿", pinyin: "Nǚ'ér", meaning: "Con gái" },
      { hanzi: "亲戚", pinyin: "Qīnqi", meaning: "Họ hàng" },
      { hanzi: "家人", pinyin: "Jiārén", meaning: "Người nhà" },
      { hanzi: "结婚", pinyin: "Jiéhūn", meaning: "Kết hôn" },
      { hanzi: "单身", pinyin: "Dānshēn", meaning: "Độc thân" },
    ],
    dialogue: [
      {
        speaker: "A",
        hanzi: "你家有几口人？",
        pinyin: "Nǐ jiā yǒu jǐ kǒu rén?",
        meaning: "Nhà bạn có mấy người?",
      },
      {
        speaker: "B",
        hanzi: "我家有四口人。",
        pinyin: "Wǒ jiā yǒu sì kǒu rén.",
        meaning: "Nhà tôi có 4 người.",
      },
      {
        speaker: "A",
        hanzi: "他们是谁？",
        pinyin: "Tāmen shì shéi?",
        meaning: "Họ là những ai?",
      },
      {
        speaker: "B",
        hanzi: "爸爸、妈妈、哥哥和我。",
        pinyin: "Bàba, māma, gēge hé wǒ.",
        meaning: "Bố, mẹ, anh trai và tôi.",
      },
      {
        speaker: "A",
        hanzi: "你哥哥多大了？",
        pinyin: "Nǐ gēge duō dà le?",
        meaning: "Anh trai bạn bao nhiêu tuổi?",
      },
      {
        speaker: "B",
        hanzi: "他二十五岁。他已经结婚了。",
        pinyin: "Tā èrshíwǔ suì. Tā yǐjīng jiéhūn le.",
        meaning: "Anh ấy 25 tuổi. Anh ấy đã kết hôn rồi.",
      },
      {
        speaker: "A",
        hanzi: "他有孩子吗？",
        pinyin: "Tā yǒu háizi ma?",
        meaning: "Anh ấy có con chưa?",
      },
      {
        speaker: "B",
        hanzi: "有一个儿子。",
        pinyin: "Yǒu yī gè érzi.",
        meaning: "Có một con trai.",
      },
      {
        speaker: "A",
        hanzi: "你呢？你结婚了吗？",
        pinyin: "Nǐ ne? Nǐ jiéhūn le ma?",
        meaning: "Còn bạn? Bạn đã kết hôn chưa?",
      },
      {
        speaker: "B",
        hanzi: "我还没结婚。我还单身。",
        pinyin: "Wǒ hái méi jiéhūn. Wǒ hái dānshēn.",
        meaning: "Tôi chưa kết hôn. Tôi vẫn độc thân.",
      },
      {
        speaker: "A",
        hanzi: "你的爷爷奶奶住在哪里？",
        pinyin: "Nǐ de yéye nǎinai zhù zài nǎlǐ?",
        meaning: "Ông bà nội bạn sống ở đâu?",
      },
      {
        speaker: "B",
        hanzi: "他们住在农村。",
        pinyin: "Tāmen zhù zài nóngcūn.",
        meaning: "Họ sống ở nông thôn.",
      },
      {
        speaker: "A",
        hanzi: "你们经常见面吗？",
        pinyin: "Nǐmen jīngcháng jiànmiàn ma?",
        meaning: "Các bạn có thường xuyên gặp nhau không?",
      },
      {
        speaker: "B",
        hanzi: "我们每个月见一次。",
        pinyin: "Wǒmen měi gè yuè jiàn yīcì.",
        meaning: "Chúng tôi mỗi tháng gặp một lần.",
      },
    ],
  },
  {
    id: "bai-6",
    title: "Bài 6: Hỏi đường",
    description: "Hỏi vị trí và hướng đi.",
    vocab: [
      { hanzi: "在哪儿", pinyin: "Zài nǎr", meaning: "Ở đâu" },
      { hanzi: "怎么走", pinyin: "Zěnme zǒu", meaning: "Đi như thế nào" },
      { hanzi: "一直走", pinyin: "Yīzhí zǒu", meaning: "Đi thẳng" },
      { hanzi: "左拐", pinyin: "Zuǒ guǎi", meaning: "Rẽ trái" },
      { hanzi: "地铁站", pinyin: "Dìtiě zhàn", meaning: "Trạm tàu điện ngầm" },
      { hanzi: "右拐", pinyin: "Yòu guǎi", meaning: "Rẽ phải" },
      { hanzi: "前面", pinyin: "Qiánmiàn", meaning: "Phía trước" },
      { hanzi: "后面", pinyin: "Hòumiàn", meaning: "Phía sau" },
      { hanzi: "左边", pinyin: "Zuǒbian", meaning: "Bên trái" },
      { hanzi: "右边", pinyin: "Yòubian", meaning: "Bên phải" },
      { hanzi: "对面", pinyin: "Duìmiàn", meaning: "Đối diện" },
      { hanzi: "旁边", pinyin: "Pángbiān", meaning: "Bên cạnh" },
      { hanzi: "附近", pinyin: "Fùjìn", meaning: "Gần đây" },
      { hanzi: "远", pinyin: "Yuǎn", meaning: "Xa" },
      { hanzi: "近", pinyin: "Jìn", meaning: "Gần" },
      { hanzi: "路口", pinyin: "Lùkǒu", meaning: "Ngã tư" },
      { hanzi: "十字路口", pinyin: "Shízì lùkǒu", meaning: "Ngã tư" },
      { hanzi: "过马路", pinyin: "Guò mǎlù", meaning: "Qua đường" },
      {
        hanzi: "公交车站",
        pinyin: "Gōngjiāo chē zhàn",
        meaning: "Trạm xe buýt",
      },
      { hanzi: "地图", pinyin: "Dìtú", meaning: "Bản đồ" },
    ],
    dialogue: [
      {
        speaker: "A",
        hanzi: "请问，地铁站在哪儿？",
        pinyin: "Qǐngwèn, dìtiě zhàn zài nǎr?",
        meaning: "Xin hỏi, trạm tàu điện ngầm ở đâu?",
      },
      {
        speaker: "B",
        hanzi: "在前面。",
        pinyin: "Zài qiánmiàn.",
        meaning: "Ở phía trước.",
      },
      {
        speaker: "A",
        hanzi: "怎么走？",
        pinyin: "Zěnme zǒu?",
        meaning: "Đi đường nào (đi như thế nào)?",
      },
      {
        speaker: "B",
        hanzi: "一直走，然后左拐。",
        pinyin: "Yīzhí zǒu, ránhòu zuǒ guǎi.",
        meaning: "Đi thẳng, sau đó rẽ trái.",
      },
      {
        speaker: "A",
        hanzi: "要走多久？",
        pinyin: "Yào zǒu duō jiǔ?",
        meaning: "Đi bao lâu?",
      },
      {
        speaker: "B",
        hanzi: "大概五分钟。",
        pinyin: "Dàgài wǔ fēnzhōng.",
        meaning: "Khoảng 5 phút.",
      },
      {
        speaker: "A",
        hanzi: "附近有公交车站吗？",
        pinyin: "Fùjìn yǒu gōngjiāo chē zhàn ma?",
        meaning: "Gần đây có trạm xe buýt không?",
      },
      {
        speaker: "B",
        hanzi: "有。地铁站对面就是公交车站。",
        pinyin: "Yǒu. Dìtiě zhàn duìmiàn jiù shì gōngjiāo chē zhàn.",
        meaning: "Có. Đối diện trạm tàu điện ngầm chính là trạm xe buýt.",
      },
      {
        speaker: "A",
        hanzi: "银行在哪儿？",
        pinyin: "Yínháng zài nǎr?",
        meaning: "Ngân hàng ở đâu?",
      },
      {
        speaker: "B",
        hanzi: "银行在右边，超市的旁边。",
        pinyin: "Yínháng zài yòubian, chāoshì de pángbiān.",
        meaning: "Ngân hàng ở bên phải, bên cạnh siêu thị.",
      },
      {
        speaker: "A",
        hanzi: "离这里远吗？",
        pinyin: "Lí zhèlǐ yuǎn ma?",
        meaning: "Có xa đây không?",
      },
      {
        speaker: "B",
        hanzi: "不远，很近。走路三分钟。",
        pinyin: "Bù yuǎn, hěn jìn. Zǒulù sān fēnzhōng.",
        meaning: "Không xa, rất gần. Đi bộ 3 phút.",
      },
      {
        speaker: "A",
        hanzi: "谢谢你的帮助！",
        pinyin: "Xièxie nǐ de bāngzhù!",
        meaning: "Cảm ơn sự giúp đỡ của bạn!",
      },
      {
        speaker: "B",
        hanzi: "不客气。",
        pinyin: "Bù kèqì.",
        meaning: "Không có gì.",
      },
    ],
  },
  {
    id: "bai-7",
    title: "Bài 7: Sở thích",
    description: "Nói về những gì bạn thích làm.",
    vocab: [
      { hanzi: "喜欢", pinyin: "Xǐhuān", meaning: "Thích" },
      { hanzi: "做什么", pinyin: "Zuò shénme", meaning: "Làm gì" },
      { hanzi: "听音乐", pinyin: "Tīng yīnyuè", meaning: "Nghe nhạc" },
      { hanzi: "看电影", pinyin: "Kàn diànyǐng", meaning: "Xem phim" },
      { hanzi: "运动", pinyin: "Yùndòng", meaning: "Thể thao" },
      { hanzi: "爱好", pinyin: "Àihào", meaning: "Sở thích" },
      { hanzi: "读书", pinyin: "Dúshū", meaning: "Đọc sách" },
      { hanzi: "旅行", pinyin: "Lǚxíng", meaning: "Du lịch" },
      { hanzi: "做饭", pinyin: "Zuò fàn", meaning: "Nấu ăn" },
      { hanzi: "画画", pinyin: "Huà huà", meaning: "Vẽ tranh" },
      { hanzi: "拍照", pinyin: "Pāi zhào", meaning: "Chụp ảnh" },
      { hanzi: "逛街", pinyin: "Guàng jiē", meaning: "Đi dạo phố" },
      { hanzi: "玩游戏", pinyin: "Wán yóuxì", meaning: "Chơi game" },
      { hanzi: "跳舞", pinyin: "Tiào wǔ", meaning: "Nhảy múa" },
      { hanzi: "唱歌", pinyin: "Chàng gē", meaning: "Hát" },
      { hanzi: "游泳", pinyin: "Yóuyǒng", meaning: "Bơi lội" },
      { hanzi: "跑步", pinyin: "Pǎobù", meaning: "Chạy bộ" },
      { hanzi: "健身", pinyin: "Jiànshēn", meaning: "Tập thể hình" },
      { hanzi: "钓鱼", pinyin: "Diào yú", meaning: "Câu cá" },
      { hanzi: "下棋", pinyin: "Xià qí", meaning: "Đánh cờ" },
    ],
    dialogue: [
      {
        speaker: "A",
        hanzi: "周末你喜欢做什么？",
        pinyin: "Zhōumò nǐ xǐhuān zuò shénme?",
        meaning: "Cuối tuần bạn thích làm gì?",
      },
      {
        speaker: "B",
        hanzi: "我喜欢在家听音乐。",
        pinyin: "Wǒ xǐhuān zài jiā tīng yīnyuè.",
        meaning: "Tôi thích ở nhà nghe nhạc.",
      },
      {
        speaker: "A",
        hanzi: "你喜欢运动吗？",
        pinyin: "Nǐ xǐhuān yùndòng ma?",
        meaning: "Bạn có thích thể thao không?",
      },
      {
        speaker: "B",
        hanzi: "不太喜欢。",
        pinyin: "Bù tài xǐhuān.",
        meaning: "Không thích lắm.",
      },
      {
        speaker: "A",
        hanzi: "那你有什么别的爱好？",
        pinyin: "Nà nǐ yǒu shénme bié de àihào?",
        meaning: "Vậy bạn có sở thích nào khác?",
      },
      {
        speaker: "B",
        hanzi: "我喜欢看电影和读书。",
        pinyin: "Wǒ xǐhuān kàn diànyǐng hé dúshū.",
        meaning: "Tôi thích xem phim và đọc sách.",
      },
      {
        speaker: "A",
        hanzi: "你喜欢看什么类型的电影？",
        pinyin: "Nǐ xǐhuān kàn shénme lèixíng de diànyǐng?",
        meaning: "Bạn thích xem thể loại phim nào?",
      },
      {
        speaker: "B",
        hanzi: "我喜欢看动作片和科幻片。",
        pinyin: "Wǒ xǐhuān kàn dòngzuò piàn hé kēhuàn piàn.",
        meaning: "Tôi thích xem phim hành động và khoa học viễn tưởng.",
      },
      {
        speaker: "A",
        hanzi: "你喜欢旅行吗？",
        pinyin: "Nǐ xǐhuān lǚxíng ma?",
        meaning: "Bạn có thích du lịch không?",
      },
      {
        speaker: "B",
        hanzi: "很喜欢！我去过很多国家。",
        pinyin: "Hěn xǐhuān! Wǒ qùguò hěnduō guójiā.",
        meaning: "Rất thích! Tôi đã đi qua nhiều nước.",
      },
      {
        speaker: "A",
        hanzi: "你最想去哪个国家？",
        pinyin: "Nǐ zuì xiǎng qù nǎge guójiā?",
        meaning: "Bạn muốn đi nước nào nhất?",
      },
      {
        speaker: "B",
        hanzi: "我想去日本。",
        pinyin: "Wǒ xiǎng qù Rìběn.",
        meaning: "Tôi muốn đi Nhật Bản.",
      },
      {
        speaker: "A",
        hanzi: "你喜欢做饭吗？",
        pinyin: "Nǐ xǐhuān zuò fàn ma?",
        meaning: "Bạn có thích nấu ăn không?",
      },
      {
        speaker: "B",
        hanzi: "不喜欢，我常常在外面吃饭。",
        pinyin: "Bù xǐhuān, wǒ chángcháng zài wàimiàn chīfàn.",
        meaning: "Không thích, tôi thường ăn ở ngoài.",
      },
    ],
  },
  {
    id: "bai-8",
    title: "Bài 8: Công việc",
    description: "Hỏi về nghề nghiệp và nơi làm việc.",
    vocab: [
      { hanzi: "工作", pinyin: "Gōngzuò", meaning: "Công việc/Làm việc" },
      { hanzi: "老师", pinyin: "Lǎoshī", meaning: "Giáo viên" },
      { hanzi: "医生", pinyin: "Yīshēng", meaning: "Bác sĩ" },
      { hanzi: "公司", pinyin: "Gōngsī", meaning: "Công ty" },
      { hanzi: "累", pinyin: "Lèi", meaning: "Mệt" },
      { hanzi: "职业", pinyin: "Zhíyè", meaning: "Nghề nghiệp" },
      { hanzi: "上班", pinyin: "Shàngbān", meaning: "Đi làm" },
      { hanzi: "下班", pinyin: "Xiàbān", meaning: "Tan làm" },
      { hanzi: "工资", pinyin: "Gōngzī", meaning: "Lương" },
      { hanzi: "同事", pinyin: "Tóngshì", meaning: "Đồng nghiệp" },
      { hanzi: "老板", pinyin: "Lǎobǎn", meaning: "Sếp" },
      { hanzi: "会议", pinyin: "Huìyì", meaning: "Cuộc họp" },
      { hanzi: "项目", pinyin: "Xiàngmù", meaning: "Dự án" },
      { hanzi: "压力", pinyin: "Yālì", meaning: "Áp lực" },
      { hanzi: "加班", pinyin: "Jiābān", meaning: "Tăng ca" },
      { hanzi: "请假", pinyin: "Qǐng jià", meaning: "Xin nghỉ" },
      { hanzi: "辞职", pinyin: "Cízhí", meaning: "Nghỉ việc" },
      { hanzi: "面试", pinyin: "Miànshì", meaning: "Phỏng vấn" },
      { hanzi: "经验", pinyin: "Jīngyàn", meaning: "Kinh nghiệm" },
      { hanzi: "技能", pinyin: "Jìnéng", meaning: "Kỹ năng" },
    ],
    dialogue: [
      {
        speaker: "A",
        hanzi: "你在哪儿工作？",
        pinyin: "Nǐ zài nǎr gōngzuò?",
        meaning: "Bạn làm việc ở đâu?",
      },
      {
        speaker: "B",
        hanzi: "我在一家公司工作。",
        pinyin: "Wǒ zài yījiā gōngsī gōngzuò.",
        meaning: "Tôi làm việc tại một công ty.",
      },
      {
        speaker: "A",
        hanzi: "工作忙吗？",
        pinyin: "Gōngzuò máng ma?",
        meaning: "Công việc có bận không?",
      },
      {
        speaker: "B",
        hanzi: "很忙，也很累。",
        pinyin: "Hěn máng, yě hěn lèi.",
        meaning: "Rất bận, cũng rất mệt.",
      },
      {
        speaker: "A",
        hanzi: "你做什么工作？",
        pinyin: "Nǐ zuò shénme gōngzuò?",
        meaning: "Bạn làm công việc gì?",
      },
      {
        speaker: "B",
        hanzi: "我是程序员。",
        pinyin: "Wǒ shì chéngxù yuán.",
        meaning: "Tôi là lập trình viên.",
      },
      {
        speaker: "A",
        hanzi: "你喜欢你的工作吗？",
        pinyin: "Nǐ xǐhuān nǐ de gōngzuò ma?",
        meaning: "Bạn có thích công việc của mình không?",
      },
      {
        speaker: "B",
        hanzi: "喜欢，但是经常加班。",
        pinyin: "Xǐhuān, dànshì jīngcháng jiābān.",
        meaning: "Thích, nhưng thường xuyên tăng ca.",
      },
      {
        speaker: "A",
        hanzi: "你的同事怎么样？",
        pinyin: "Nǐ de tóngshì zěnmeyàng?",
        meaning: "Đồng nghiệp của bạn thế nào?",
      },
      {
        speaker: "B",
        hanzi: "他们很友好，我们经常一起吃饭。",
        pinyin: "Tāmen hěn yǒuhǎo, wǒmen jīngcháng yīqǐ chīfàn.",
        meaning: "Họ rất thân thiện, chúng tôi thường cùng nhau ăn cơm.",
      },
      {
        speaker: "A",
        hanzi: "你工资高吗？",
        pinyin: "Nǐ gōngzī gāo ma?",
        meaning: "Lương của bạn cao không?",
      },
      {
        speaker: "B",
        hanzi: "还可以。",
        pinyin: "Hái kěyǐ.",
        meaning: "Cũng được.",
      },
      {
        speaker: "A",
        hanzi: "你打算换工作吗？",
        pinyin: "Nǐ dǎsuàn huàn gōngzuò ma?",
        meaning: "Bạn có dự định đổi việc không?",
      },
      {
        speaker: "B",
        hanzi: "目前没有。",
        pinyin: "Mùqián méiyǒu.",
        meaning: "Hiện tại thì chưa.",
      },
      {
        speaker: "A",
        hanzi: "你工作几年了？",
        pinyin: "Nǐ gōngzuò jǐ nián le?",
        meaning: "Bạn làm việc mấy năm rồi?",
      },
      {
        speaker: "B",
        hanzi: "五年了。",
        pinyin: "Wǔ nián le.",
        meaning: "5 năm rồi.",
      },
    ],
  },
  {
    id: "bai-9",
    title: "Bài 9: Thời tiết",
    description: "Hỏi thăm về thời tiết hôm nay.",
    vocab: [
      { hanzi: "天气", pinyin: "Tiānqì", meaning: "Thời tiết" },
      { hanzi: "怎么样", pinyin: "Zěnmeyàng", meaning: "Như thế nào" },
      { hanzi: "热", pinyin: "Rè", meaning: "Nóng" },
      { hanzi: "冷", pinyin: "Lěng", meaning: "Lạnh" },
      { hanzi: "下雨", pinyin: "Xià yǔ", meaning: "Mưa" },
      { hanzi: "晴天", pinyin: "Qíngtiān", meaning: "Trời nắng" },
      { hanzi: "阴天", pinyin: "Yīntiān", meaning: "Trời âm u" },
      { hanzi: "多云", pinyin: "Duōyún", meaning: "Nhiều mây" },
      { hanzi: "刮风", pinyin: "Guā fēng", meaning: "Gió thổi" },
      { hanzi: "下雪", pinyin: "Xià xuě", meaning: "Tuyết rơi" },
      { hanzi: "温度", pinyin: "Wēndù", meaning: "Nhiệt độ" },
      { hanzi: "摄氏度", pinyin: "Shèshì dù", meaning: "Độ C" },
      {
        hanzi: "天气预报",
        pinyin: "Tiānqì yùbào",
        meaning: "Dự báo thời tiết",
      },
      { hanzi: "季节", pinyin: "Jìjié", meaning: "Mùa" },
      { hanzi: "春天", pinyin: "Chūntiān", meaning: "Mùa xuân" },
      { hanzi: "夏天", pinyin: "Xiàtiān", meaning: "Mùa hè" },
      { hanzi: "秋天", pinyin: "Qiūtiān", meaning: "Mùa thu" },
      { hanzi: "冬天", pinyin: "Dōngtiān", meaning: "Mùa đông" },
      { hanzi: "潮湿", pinyin: "Cháoshī", meaning: "Ẩm ướt" },
      { hanzi: "干燥", pinyin: "Gānzào", meaning: "Khô ráo" },
    ],
    dialogue: [
      {
        speaker: "A",
        hanzi: "今天天气怎么样？",
        pinyin: "Jīntiān tiānqì zěnmeyàng?",
        meaning: "Thời tiết hôm nay thế nào?",
      },
      {
        speaker: "B",
        hanzi: "今天很热。",
        pinyin: "Jīntiān hěn rè.",
        meaning: "Hôm nay rất nóng.",
      },
      {
        speaker: "A",
        hanzi: "明天会下雨吗？",
        pinyin: "Míngtiān huì xià yǔ ma?",
        meaning: "Ngày mai có mưa không?",
      },
      {
        speaker: "B",
        hanzi: "明天不冷也不热。",
        pinyin: "Míngtiān bù lěng yě bù rè.",
        meaning: "Ngày mai không lạnh cũng không nóng.",
      },
      {
        speaker: "A",
        hanzi: "今天多少度？",
        pinyin: "Jīntiān duōshǎo dù?",
        meaning: "Hôm nay bao nhiêu độ?",
      },
      {
        speaker: "B",
        hanzi: "三十摄氏度。",
        pinyin: "Sānshí shèshì dù.",
        meaning: "30 độ C.",
      },
      {
        speaker: "A",
        hanzi: "太热了！我喜欢秋天。",
        pinyin: "Tài rè le! Wǒ xǐhuān qiūtiān.",
        meaning: "Nóng quá! Tôi thích mùa thu.",
      },
      {
        speaker: "B",
        hanzi: "我也喜欢秋天。天气不冷也不热。",
        pinyin: "Wǒ yě xǐhuān qiūtiān. Tiānqì bù lěng yě bù rè.",
        meaning:
          "Tôi cũng thích mùa thu. Thời tiết không lạnh cũng không nóng.",
      },
      {
        speaker: "A",
        hanzi: "你看了天气预报吗？",
        pinyin: "Nǐ kànle tiānqì yùbào ma?",
        meaning: "Bạn xem dự báo thời tiết chưa?",
      },
      {
        speaker: "B",
        hanzi: "看了。明天会下雨。",
        pinyin: "Kànle. Míngtiān huì xià yǔ.",
        meaning: "Xem rồi. Ngày mai sẽ mưa.",
      },
      {
        speaker: "A",
        hanzi: "那我们应该带伞。",
        pinyin: "Nà wǒmen yīnggāi dài sǎn.",
        meaning: "Vậy chúng ta nên mang ô.",
      },
      {
        speaker: "B",
        hanzi: "对。你喜欢冬天吗？",
        pinyin: "Duì. Nǐ xǐhuān dōngtiān ma?",
        meaning: "Đúng rồi. Bạn có thích mùa đông không?",
      },
      {
        speaker: "A",
        hanzi: "不喜欢，太冷了。",
        pinyin: "Bù xǐhuān, tài lěng le.",
        meaning: "Không thích, lạnh quá.",
      },
      {
        speaker: "B",
        hanzi: "我喜欢冬天，因为可以滑雪。",
        pinyin: "Wǒ xǐhuān dōngtiān, yīnwèi kěyǐ huáxuě.",
        meaning: "Tôi thích mùa đông, vì có thể trượt tuyết.",
      },
    ],
  },
  {
    id: "bai-10",
    title: "Bài 10: Sức khỏe",
    description: "Nói về tình trạng sức khỏe đơn giản.",
    vocab: [
      { hanzi: "身体", pinyin: "Shēntǐ", meaning: "Cơ thể/Sức khỏe" },
      { hanzi: "不舒服", pinyin: "Bù shūfú", meaning: "Không khỏe/Khó chịu" },
      { hanzi: "生病", pinyin: "Shēngbìng", meaning: "Bị ốm" },
      { hanzi: "去", pinyin: "Qù", meaning: "Đi" },
      { hanzi: "医院", pinyin: "Yīyuàn", meaning: "Bệnh viện" },
      { hanzi: "感冒", pinyin: "Gǎnmào", meaning: "Cảm lạnh" },
      { hanzi: "发烧", pinyin: "Fāshāo", meaning: "Sốt" },
      { hanzi: "头疼", pinyin: "Tóu téng", meaning: "Đau đầu" },
      { hanzi: "咳嗽", pinyin: "Késòu", meaning: "Ho" },
      { hanzi: "药", pinyin: "Yào", meaning: "Thuốc" },
      { hanzi: "医生", pinyin: "Yīshēng", meaning: "Bác sĩ" },
      { hanzi: "检查", pinyin: "Jiǎnchá", meaning: "Kiểm tra" },
      { hanzi: "治疗", pinyin: "Zhìliáo", meaning: "Điều trị" },
      { hanzi: "休息", pinyin: "Xiūxí", meaning: "Nghỉ ngơi" },
      { hanzi: "健康", pinyin: "Jiànkāng", meaning: "Khỏe mạnh" },
      { hanzi: "锻炼", pinyin: "Duànliàn", meaning: "Tập luyện" },
      { hanzi: "饮食", pinyin: "Yǐnshí", meaning: "Ăn uống" },
      { hanzi: "睡眠", pinyin: "Shuìmián", meaning: "Giấc ngủ" },
      { hanzi: "压力", pinyin: "Yālì", meaning: "Áp lực" },
      { hanzi: "预防", pinyin: "Yùfáng", meaning: "Phòng ngừa" },
    ],
    dialogue: [
      {
        speaker: "A",
        hanzi: "你身体好吗？",
        pinyin: "Nǐ shēntǐ hǎo ma?",
        meaning: "Sức khỏe bạn tốt không?",
      },
      {
        speaker: "B",
        hanzi: "我有点不舒服。",
        pinyin: "Wǒ yǒudiǎn bù shūfú.",
        meaning: "Tôi hơi khó chịu trong người.",
      },
      {
        speaker: "A",
        hanzi: "你去医院了吗？",
        pinyin: "Nǐ qù yīyuàn le ma?",
        meaning: "Bạn đi bệnh viện chưa?",
      },
      {
        speaker: "B",
        hanzi: "还没，我想休息一下。",
        pinyin: "Hái méi, wǒ xiǎng xiūxí yīxià.",
        meaning: "Vẫn chưa, tôi muốn nghỉ ngơi một chút.",
      },
      {
        speaker: "A",
        hanzi: "你怎么了？",
        pinyin: "Nǐ zěnme le?",
        meaning: "Bạn bị sao vậy?",
      },
      {
        speaker: "B",
        hanzi: "我头疼，还有一点咳嗽。",
        pinyin: "Wǒ tóu téng, hái yǒu yīdiǎn késòu.",
        meaning: "Tôi đau đầu, và hơi ho một chút.",
      },
      {
        speaker: "A",
        hanzi: "你可能感冒了。你应该去看医生。",
        pinyin: "Nǐ kěnéng gǎnmào le. Nǐ yīnggāi qù kàn yīshēng.",
        meaning: "Có lẽ bạn bị cảm rồi. Bạn nên đi khám bác sĩ.",
      },
      {
        speaker: "B",
        hanzi: "我吃过药了。",
        pinyin: "Wǒ chī guò yào le.",
        meaning: "Tôi đã uống thuốc rồi.",
      },
      {
        speaker: "A",
        hanzi: "多喝水，多休息。",
        pinyin: "Duō hē shuǐ, duō xiūxí.",
        meaning: "Uống nhiều nước, nghỉ ngơi nhiều.",
      },
      {
        speaker: "B",
        hanzi: "谢谢关心。",
        pinyin: "Xièxie guānxīn.",
        meaning: "Cảm ơn sự quan tâm.",
      },
      {
        speaker: "A",
        hanzi: "你平时怎么保持健康？",
        pinyin: "Nǐ píngshí zěnme bǎochí jiànkāng?",
        meaning: "Bình thường bạn giữ gìn sức khỏe thế nào?",
      },
      {
        speaker: "B",
        hanzi: "我经常锻炼，也注意饮食。",
        pinyin: "Wǒ jīngcháng duànliàn, yě zhùyì yǐnshí.",
        meaning: "Tôi thường xuyên tập luyện, cũng chú ý ăn uống.",
      },
      {
        speaker: "A",
        hanzi: "你每天睡几个小时？",
        pinyin: "Nǐ měitiān shuì jǐ gè xiǎoshí?",
        meaning: "Mỗi ngày bạn ngủ mấy tiếng?",
      },
      {
        speaker: "B",
        hanzi: "我睡七到八个小时。",
        pinyin: "Wǒ shuì qī dào bā gè xiǎoshí.",
        meaning: "Tôi ngủ 7 đến 8 tiếng.",
      },
    ],
  },
  {
    id: "bai-11",
    title: "Bài 11: Đi Taxi",
    description: "Cách gọi xe và chỉ đường cho tài xế.",
    vocab: [
      { hanzi: "出租车", pinyin: "Chūzū chē", meaning: "Taxi" },
      { hanzi: "司机", pinyin: "Sījī", meaning: "Tài xế" },
      { hanzi: "机场", pinyin: "Jīchǎng", meaning: "Sân bay" },
      { hanzi: "快", pinyin: "Kuài", meaning: "Nhanh" },
      { hanzi: "到了", pinyin: "Dào le", meaning: "Đến nơi rồi" },
      { hanzi: "打车", pinyin: "Dǎ chē", meaning: "Bắt taxi" },
      { hanzi: "目的地", pinyin: "Mùdìdì", meaning: "Điểm đến" },
      { hanzi: "地址", pinyin: "Dìzhǐ", meaning: "Địa chỉ" },
      { hanzi: "路线", pinyin: "Lùxiàn", meaning: "Tuyến đường" },
      { hanzi: "堵车", pinyin: "Dǔchē", meaning: "Kẹt xe" },
      { hanzi: "高速", pinyin: "Gāosù", meaning: "Đường cao tốc" },
      { hanzi: "停车", pinyin: "Tíngchē", meaning: "Đỗ xe" },
      { hanzi: "计价器", pinyin: "Jìjià qì", meaning: "Đồng hồ tính tiền" },
      { hanzi: "车费", pinyin: "Chēfèi", meaning: "Tiền xe" },
      { hanzi: "小费", pinyin: "Xiǎofèi", meaning: "Tiền boa" },
      { hanzi: "安全带", pinyin: "Ānquán dài", meaning: "Dây an toàn" },
      { hanzi: "空调", pinyin: "Kōngtiáo", meaning: "Điều hòa" },
      { hanzi: "窗户", pinyin: "Chuānghu", meaning: "Cửa sổ" },
      { hanzi: "行李", pinyin: "Xíngli", meaning: "Hành lý" },
      { hanzi: "后备箱", pinyin: "Hòubèi xiāng", meaning: "Cốp xe" },
    ],
    dialogue: [
      {
        speaker: "A",
        hanzi: "司机，我要去机场。",
        pinyin: "Sījī, wǒ yào qù jīchǎng.",
        meaning: "Bác tài, tôi muốn đi sân bay.",
      },
      {
        speaker: "B",
        hanzi: "好的，请上车。",
        pinyin: "Hǎo de, qǐng shàng chē.",
        meaning: "Được, mời lên xe.",
      },
      {
        speaker: "A",
        hanzi: "请开快一点。",
        pinyin: "Qǐng kāi kuài yīdiǎn.",
        meaning: "Làm ơn lái nhanh một chút.",
      },
      {
        speaker: "B",
        hanzi: "没问题。到了！",
        pinyin: "Méi wèntí. Dào le!",
        meaning: "Không vấn đề. Đến nơi rồi!",
      },
      {
        speaker: "A",
        hanzi: "请帮我拿一下行李。",
        pinyin: "Qǐng bāng wǒ ná yīxià xíngli.",
        meaning: "Làm ơn giúp tôi lấy hành lý.",
      },
      {
        speaker: "B",
        hanzi: "好的。请系好安全带。",
        pinyin: "Hǎo de. Qǐng jì hǎo ānquán dài.",
        meaning: "Được. Hãy thắt dây an toàn.",
      },
      {
        speaker: "A",
        hanzi: "去机场要多久？",
        pinyin: "Qù jīchǎng yào duō jiǔ?",
        meaning: "Đi sân bay mất bao lâu?",
      },
      {
        speaker: "B",
        hanzi: "如果不堵车，大概四十分钟。",
        pinyin: "Rúguǒ bù dǔchē, dàgài sìshí fēnzhōng.",
        meaning: "Nếu không kẹt xe, khoảng 40 phút.",
      },
      {
        speaker: "A",
        hanzi: "请走高速，我赶时间。",
        pinyin: "Qǐng zǒu gāosù, wǒ gǎn shíjiān.",
        meaning: "Xin đi đường cao tốc, tôi đang vội.",
      },
      {
        speaker: "B",
        hanzi: "可以。高速费您需要自己付。",
        pinyin: "Kěyǐ. Gāosù fèi nín xūyào zìjǐ fù.",
        meaning: "Được. Phí cao tốc quý khách cần tự trả.",
      },
      {
        speaker: "A",
        hanzi: "好的。可以开一下空调吗？",
        pinyin: "Hǎo de. Kěyǐ kāi yīxià kōngtiáo ma?",
        meaning: "Được. Có thể bật điều hòa không?",
      },
      {
        speaker: "B",
        hanzi: "当然可以。",
        pinyin: "Dāngrán kěyǐ.",
        meaning: "Đương nhiên rồi.",
      },
      {
        speaker: "A",
        hanzi: "多少钱？",
        pinyin: "Duōshǎo qián?",
        meaning: "Bao nhiêu tiền?",
      },
      {
        speaker: "B",
        hanzi: "一百二十块。",
        pinyin: "Yībǎi èrshí kuài.",
        meaning: "120 tệ.",
      },
      {
        speaker: "A",
        hanzi: "这是一百三十块，不用找了。",
        pinyin: "Zhè shì yībǎi sānshí kuài, bùyòng zhǎo le.",
        meaning: "Đây là 130 tệ, không cần thối lại.",
      },
      {
        speaker: "B",
        hanzi: "谢谢！",
        pinyin: "Xièxie!",
        meaning: "Cảm ơn!",
      },
    ],
  },
  {
    id: "bai-12",
    title: "Bài 12: Khách sạn",
    description: "Làm thủ tục nhận phòng khách sạn.",
    vocab: [
      { hanzi: "酒店", pinyin: "Jiǔdiàn", meaning: "Khách sạn" },
      { hanzi: "预订", pinyin: "Yùdìng", meaning: "Đặt trước" },
      { hanzi: "房间", pinyin: "Fángjiān", meaning: "Phòng" },
      { hanzi: "护照", pinyin: "Hùzhào", meaning: "Hộ chiếu" },
      { hanzi: "房卡", pinyin: "Fáng kǎ", meaning: "Thẻ phòng" },
      { hanzi: "前台", pinyin: "Qiántái", meaning: "Quầy lễ tân" },
      { hanzi: "入住", pinyin: "Rùzhù", meaning: "Nhận phòng" },
      { hanzi: "退房", pinyin: "Tuìfáng", meaning: "Trả phòng" },
      { hanzi: "单人间", pinyin: "Dānrén jiān", meaning: "Phòng đơn" },
      { hanzi: "双人间", pinyin: "Shuāngrén jiān", meaning: "Phòng đôi" },
      { hanzi: "套房", pinyin: "Tào fáng", meaning: "Phòng suite" },
      { hanzi: "浴室", pinyin: "Yùshì", meaning: "Phòng tắm" },
      { hanzi: " wifi", pinyin: "Wǎifài", meaning: "Wifi" },
      { hanzi: "早餐", pinyin: "Zǎocān", meaning: "Bữa sáng" },
      { hanzi: "服务", pinyin: "Fúwù", meaning: "Dịch vụ" },
      { hanzi: "叫醒", pinyin: "Jiàoxǐng", meaning: "Đánh thức" },
      { hanzi: "洗衣", pinyin: "Xǐyī", meaning: "Giặt là" },
      { hanzi: "健身房", pinyin: "Jiànshēnfáng", meaning: "Phòng gym" },
      { hanzi: "游泳池", pinyin: "Yóuyǒng chí", meaning: "Hồ bơi" },
      { hanzi: "停车场", pinyin: "Tíngchē chǎng", meaning: "Bãi đỗ xe" },
    ],
    dialogue: [
      {
        speaker: "A",
        hanzi: "你好，我要办入住。",
        pinyin: "Nǐ hǎo, wǒ yào bàn rùzhù.",
        meaning: "Xin chào, tôi muốn làm thủ tục nhận phòng.",
      },
      {
        speaker: "B",
        hanzi: "你预订了吗？",
        pinyin: "Nǐ yùdìng le ma?",
        meaning: "Quý khách đã đặt trước chưa?",
      },
      {
        speaker: "A",
        hanzi: "预订了。这是我的护照。",
        pinyin: "Yùdìng le. Zhè shì wǒ de hùzhào.",
        meaning: "Đặt rồi. Đây là hộ chiếu của tôi.",
      },
      {
        speaker: "B",
        hanzi: "好的，这是你的房卡。",
        pinyin: "Hǎo de, zhè shì nǐ de fáng kǎ.",
        meaning: "Vâng, đây là thẻ phòng của quý khách.",
      },
      {
        speaker: "A",
        hanzi: "我的房间在几楼？",
        pinyin: "Wǒ de fángjiān zài jǐ lóu?",
        meaning: "Phòng của tôi ở tầng mấy?",
      },
      {
        speaker: "B",
        hanzi: "十二楼，1208号房间。",
        pinyin: "Shí'èr lóu, yāo'èr líng bā hào fángjiān.",
        meaning: "Tầng 12, phòng 1208.",
      },
      {
        speaker: "A",
        hanzi: "早餐几点开始？",
        pinyin: "Zǎocān jǐ diǎn kāishǐ?",
        meaning: "Bữa sáng mấy giờ bắt đầu?",
      },
      {
        speaker: "B",
        hanzi: "早上六点到十点。",
        pinyin: "Zǎoshang liù diǎn dào shí diǎn.",
        meaning: "Từ 6 giờ đến 10 giờ sáng.",
      },
      {
        speaker: "A",
        hanzi: " wifi密码是多少？",
        pinyin: "Wǎifài mìmǎ shì duōshǎo?",
        meaning: "Mật khẩu wifi là gì?",
      },
      {
        speaker: "B",
        hanzi: "房间号加上1234。",
        pinyin: "Fángjiān hào jiā shàng yāo'èr sān sì.",
        meaning: "Số phòng cộng với 1234.",
      },
      {
        speaker: "A",
        hanzi: "明天早上七点请叫醒我。",
        pinyin: "Míngtiān zǎoshang qī diǎn qǐng jiàoxǐng wǒ.",
        meaning: "Sáng mai 7 giờ xin đánh thức tôi.",
      },
      {
        speaker: "B",
        hanzi: "好的。您需要洗衣服务吗？",
        pinyin: "Hǎo de. Nín xūyào xǐyī fúwù ma?",
        meaning: "Vâng. Quý khách có cần dịch vụ giặt là không?",
      },
      {
        speaker: "A",
        hanzi: "需要。洗衣房在哪儿？",
        pinyin: "Xūyào. Xǐyī fáng zài nǎr?",
        meaning: "Cần. Phòng giặt ở đâu?",
      },
      {
        speaker: "B",
        hanzi: "在三楼。",
        pinyin: "Zài sān lóu.",
        meaning: "Ở tầng 3.",
      },
      {
        speaker: "A",
        hanzi: "几点退房？",
        pinyin: "Jǐ diǎn tuìfáng?",
        meaning: "Mấy giờ trả phòng?",
      },
      {
        speaker: "B",
        hanzi: "中午十二点前。",
        pinyin: "Zhōngwǔ shí'èr diǎn qián.",
        meaning: "Trước 12 giờ trưa.",
      },
      {
        speaker: "A",
        hanzi: "好的，谢谢。",
        pinyin: "Hǎo de, xièxie.",
        meaning: "Được, cảm ơn.",
      },
    ],
  },
];
